var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11032_6955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 24.1686L19.9999 27.5019M19.9999 27.5019L23.3333 24.1686M19.9999 27.5019V20.0019M27.3999 25.0769C28.1244 24.5674 28.6677 23.8404 28.951 23.0012C29.2343 22.162 29.2428 21.2544 28.9753 20.4101C28.7078 19.5658 28.1782 18.8286 27.4633 18.3057C26.7485 17.7828 25.8856 17.5012 24.9999 17.5019H23.9499C23.6993 16.5251 23.2304 15.6179 22.5784 14.8486C21.9264 14.0793 21.1084 13.4679 20.186 13.0605C19.2635 12.6531 18.2606 12.4603 17.2529 12.4965C16.2451 12.5327 15.2587 12.7971 14.3679 13.2698C13.4771 13.7424 12.7051 14.4109 12.1101 15.2251C11.5151 16.0392 11.1125 16.9778 10.9327 17.97C10.7528 18.9623 10.8005 19.9824 11.0719 20.9536C11.3434 21.9248 11.8317 22.8217 12.4999 23.5769",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11032_6955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownload);
export default __webpack_public_path__ + "static/media/cloud-download.129c94cd.svg";
export { ForwardRef as ReactComponent };